import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

const DiPdfPreview = ({ blob, onClose, title = "PDF D.I." }) => {
 const [url, setUrl] = useState('');
 const { t } = useTranslation(['listDataForms']);
 useEffect(() => {
  if (!blob) { setUrl(''); return; }
  const next = URL.createObjectURL(blob); setUrl(next);
  return () => URL.revokeObjectURL(next);
 }, [blob]);
 return <Dialog open={Boolean(blob)} onClose={onClose} maxWidth={false}
  PaperProps={{ sx: { width: '92vw', maxWidth: '92vw', height: '90dvh', minHeight: '80vh', margin: '4vw', overflow: 'hidden' } }}>
  <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:8,padding:'8px 12px'}}>
   <strong>{title}</strong>
   <div style={{display:'flex',gap:8}}>
    <Button component="a" href={url || undefined} target="_blank" rel="noopener noreferrer">{t('Button_Open_PDF')}</Button>
    <Button onClick={onClose}>{t('Button_Close_PDF')}</Button>
   </div>
  </div>
  {url && <iframe title={title} src={url + '#view=FitH'} style={{width:'100%',flex:1,minHeight:0,border:0}} />}
 </Dialog>;
};
DiPdfPreview.propTypes = { title: PropTypes.string, blob: PropTypes.object, onClose: PropTypes.func.isRequired };
export default DiPdfPreview;
